export const CityOverview = ({ city }) => (
<>
<p className="text-base md:text-lg">
                      <strong className="text-yellow-400">Maître Diamma</strong>, grand <strong className="text-white">marabout africain</strong> et <strong className="text-white">sorcier vaudou haïtien</strong>{' '}
                      reconnu, intervient à <strong className="text-yellow-400">{city}</strong> pour tous vos besoins spirituels urgents. 
                      Spécialiste du <strong className="text-yellow-400">retour affectif rapide à {city}</strong>, ce puissant marabout africain réalise 
                      des rituels de magie blanche, magie rouge, magie noire, désenvoûtement et voyance.{' '}
                      <strong className="text-white">Consultation disponible 7j/7 à {city}</strong>.
                    </p>
                    
                    <p className="text-base md:text-lg">
                      Vous habitez à <strong className="text-white">{city}</strong> et vous cherchez un <strong className="text-yellow-400">marabout sérieux pour retour affectif</strong> ? 
                      Un <strong className="text-yellow-400">sorcier vaudou puissant</strong> pour récupérer votre ex ? 
                      Un <strong className="text-yellow-400">voyant médium</strong> pour connaître votre avenir ? 
                      Maître Diamma est le <strong className="text-white">marabout africain le plus réputé de {city}</strong>. 
                      Ses rituels de retour affectif annoncent des résultats sous 3 à 7 jours avec un taux de réussite de 97%.
                    </p>
</>
);
